import { NgModule, Injector } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

// components
import { AccountCenterDetailedViewComponent } from '../../../../../coverpath-common/angular/components/account-center/detailed-view/account-center-detailed-view.component';
import { AccountCenterTemplateComponent } from '../../../../../coverpath-common/angular/components/account-center/utilities/account-center-template.component';
import { Auth0CallbackComponent } from '../../../../../coverpath-common/angular/services/authentication/auth0callback.component';
import { PartialIncludeComponent } from '../../../../../coverpath-common/angular/components/account-center/partial-include.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TransitionPartialComponent } from '../../../../../coverpath-common/angular/components/account-center/partials/transition-partial.component';
import { CorrectionPartialComponent } from '../../../../../coverpath-common/angular/components/account-center/partials/correction-partial.component';
import { AccountCenterTable } from '../../../../../coverpath-common/angular/components/account-center/account-center-table/account-center-table.component';
import { PolicyInfoTableComponent } from '../../../../../coverpath-common/angular/components/account-center/policy-info-table/policy-info-table.component';
import { PolicySummaryComponent } from '../../../../../coverpath-common/angular/components/account-center/policy-summary.component';
import { AbbreviateNumberPipe } from '../../../../../coverpath-common/angular/classes/AbbreviateNumberPipe';
import { PolicyDetailsTableComponent } from '../../../../../coverpath-common/angular/components/account-center/policy-details-table/policy-details-table.component';
import { PaymentDetailsTableComponent } from '../../../../../coverpath-common/angular/components/account-center/payment-details-table/payment-details-table.component';
import { TransitionCardComponent } from './transition-card/transition-card.component';
import { CorrectionFormComponent } from '../../../../../coverpath-common/angular/components/account-center/correction-form/correction-form.component';
import { LegalInfoFormComponent } from '../../../../../coverpath-common/angular/components/account-center/correction-form/legal-info-form/legal-info-form.component';
import { LicenseFormComponent } from '../../../../../coverpath-common/angular/components/account-center/correction-form/license-form/license-form.component';
import { SSNFormComponent } from '../../../../../coverpath-common/angular/components/account-center/correction-form/ssn-form/ssn-form.component';
import { PolicyLinksComponent } from '../account-center/policy-links/policy-links.component';
import { AdvisorLinksComponent } from '../../../../../coverpath-common/angular/components/account-center/advisor-links/advisor-links.component';
import { PolicyBannerComponent } from '../account-center/policy-banner/policy-banner.component';
import { AnnuityOverviewCardComponent } from '../../../../../coverpath-common/angular/components/account-center/annuity-overview-card/annuity-overview-card.component';
import { AnnuitySummaryComponent } from '../../../../../coverpath-common/angular/components/account-center/annuity-summary/annuity-summary.component';
import { AnnuityInfoTableComponent } from '../../../../../coverpath-common/angular/components/account-center/annuity-info-table/annuity-info-table.component';
import { AnnuityDetailsTableComponent } from '../../../../../coverpath-common/angular/components/account-center/annuity-details-table/annuity-details-table.component';
import { AnnuityLinksComponent } from '../../../../../coverpath-client/public/js/components/account-center/annuity-links/annuity-links.component';
import { AnnuityBannerComponent } from '../../../../../coverpath-client/public/js/components/account-center/annuity-banner/annuity-banner.component';
import { Exchange1035BreakdownComponent } from '../../../../../coverpath-common/angular/components/account-center/policy-details-table/exchange-1035-breakdown/exchange-1035-breakdown.component';
import { CashValueComponent } from '../../../../../coverpath-common/angular/components/shared/cash-value/cash-value.component';
// services
import { AccountCenterService } from '../../../../../coverpath-common/angular/services/account-center/account-center.service';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { AuthenticationResolver } from '../../../../../coverpath-common/angular/resolvers/authentication/AuthenticationResolver';
import { WorkflowService } from '../../../../../coverpath-common/angular/services/workflow/workflow.service';

// modules
import { SharedModule } from '../../../../../coverpath-common/angular/components/shared/shared.module';
import { LoadingModule } from '../../../../../coverpath-common/angular/components/shared/loading/loading.module';
import { SpinnerModule } from '../../../../../coverpath-common/angular/components/shared/spinner/spinner.module';
import { BaseFormModule } from '../../../../../coverpath-common/angular/components/form/base-form.module';
import { PoliciesOverviewComponent } from '../../../../../coverpath-common/angular/components/account-center/overview/policies-overview.component';
import { PolicyOverviewCardComponent } from '../../../../../coverpath-common/angular/components/account-center/policy-overview-card/policy-overview-card.component';
import { ReactiveFormsModule } from '@angular/forms';
import { Auth0Service } from '../../../../../coverpath-common/angular/services/authentication/auth0.service';
import { ToasterModule } from '../../../../../coverpath-common/angular/components/overlays/toaster/toaster.module';
import { CpPopoverModule } from '../../../../../coverpath-common/components/cp-popover/cp-popover.module';
import { CpIconModule } from '../../../../../coverpath-common/components/cp-icon/cp-icon.module';
import { DesignSystemModule } from '@hit/coverpath-design-system';

export const AccountCenterComponents = [
    AccountCenterDetailedViewComponent,
    PoliciesOverviewComponent,
    PolicyOverviewCardComponent,
    AccountCenterTable,
    AccountCenterTemplateComponent,
    TransitionPartialComponent,
    CorrectionPartialComponent,
    PolicyBannerComponent,
    PolicySummaryComponent,
    PartialIncludeComponent,
    PolicyDetailsTableComponent,
    PaymentDetailsTableComponent,
    PolicyInfoTableComponent,
    PolicyLinksComponent,
    AdvisorLinksComponent,
    TransitionCardComponent,
    CorrectionFormComponent,
    LegalInfoFormComponent,
    LicenseFormComponent,
    SSNFormComponent,
    AnnuityOverviewCardComponent,
    AnnuitySummaryComponent,
    AnnuityInfoTableComponent,
    AnnuityDetailsTableComponent,
    AnnuityLinksComponent,
    AnnuityBannerComponent,
    Exchange1035BreakdownComponent,
    CashValueComponent
];

@NgModule({
    declarations: [
        AccountCenterComponents,
        AbbreviateNumberPipe,
        Auth0CallbackComponent
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        FormsModule,
        SharedModule,
        LoadingModule,
        SpinnerModule,
        BaseFormModule,
        ReactiveFormsModule,
        ToasterModule,
        RouterModule,
        CpPopoverModule,
        CpIconModule,
        DesignSystemModule
    ],
    exports: [
        AbbreviateNumberPipe,
        ReactiveFormsModule
    ],
    providers: [
        AccountCenterService,
        AmorphicService,
        Auth0Service,
        AuthenticationResolver,
        WorkflowService
    ],
    bootstrap: []
})
export class AccountCenterModule {
    /**
     * Allows for retrieving singletons using `AppModule.injector.get(MyService)`
     * (whereas `ReflectiveInjector.resolveAndCreate(MyService)` would create a
     * new instance of the service).
     */
    static injector: Injector;
    constructor(injector: Injector) { }
}
